<div class="card b-0 mt-3 mt-lg-0 border rounded">
  <div class="card-body">
    <div class="toggle-container">
      <button
        (click)="setTransactionType(type.loyalty)"
        class="toggle-transaction"
        [ngClass]="{ 'button-active': transactionType == type.loyalty }"
      >
        {{ 'button.toggle.point' | translate }}
      </button>
      <button
        (click)="setTransactionType(type.ecash)"
        class="toggle-transaction"
        [ngClass]="{ 'button-active': transactionType == type.ecash }"
      >
        {{ 'button.toggle.ecash' | translate }}
      </button>
    </div>
    <div class="d-flex flex-column flex-lg-row justify-content-between">
      <div class="date-picker-container">
        <fgbcl-date-range-picker [(startDate)]="transactionStartDate" [(endDate)]="transactionEndDate"></fgbcl-date-range-picker>
      </div>
      <button type="button" class="search-button fw-bold d-block border-0 rounded text-white bg-primary" (click)="search()">
        {{ 'trans.history.search.button' | translate }}
      </button>
    </div>
  </div>
</div>

<fgb-transaction-list
  *ngIf="selectedValues"
  [startDate]="selectedValues.start"
  [endDate]="selectedValues.end"
  [memberId]="memberId"
  [transactionType]="selectedValues.type"
></fgb-transaction-list>
